import {CLAIM_TYPE} from './dropdown';
export const DOC_TYPES = [
  {value: 'asset', label: 'Asset'},
  {value: 'policy', label: 'Policy'},
  {value: 'claim', label: 'Claim'},
  {value: 'entity', label: 'Organization'},
  {value: 'government', label: 'Government'}
];

export const DOC_SUBTYPE = {
  asset: [
    {
      label: 'Real Estate',
      value: 'realEstate',
      fileTypes: [
        {
          value: 'imageFiles',
          label: 'Image Files'
        },
        {value: 'settlementDocs', label: 'Settlement Docs'},
        {value: 'rValueDocs', label: 'Replacement Value Docs'},
        {value: 'flElCertDocs', label: 'Flood Elevation Cert Docs'},
        {value: 'huReportDocs', label: 'Hurricane Report Docs'},
        {value: 'earthquakeDocs', label: 'Earthquake Docs'},
        {value: 'leaseDocs', label: 'Lease Docs'},
        {value: 'loanDocs', label: 'Loan Docs'},
        {value: 'easementAndLegalDocs', label: 'Easements & Legal Docs'},
        {value: 'alarmAndSecurityCertificate', label: 'Alarm & Security Certificate'}
      ]
    },
    {
      label: 'Collections',
      value: 'collection',
      fileTypes: [
        {value: 'inAppDocs', label: 'Insurance Appraisal Docs'},
        {value: 'esAppDocs', label: 'Estate Appraisal Docs'},
        {value: 'conAgrDocs', label: 'Consigment Agreements'},
        {value: 'lonAgrDocs', label: 'Loan Agreements'},
        {value: 'purDocs', label: 'Purchase Docs'},
        {value: 'imageFiles', label: 'Asset Images'}
      ]
    },
    {
      label: 'Automobiles',
      value: 'automobile',
      fileTypes: [
        {value: 'rValueDocs', label: 'Replacement Value Docs'},
        {value: 'purDocs', label: 'Purchase Docs'},
        {value: 'valDocs', label: 'Valuation Docs'},
        {value: 'mRecords', label: 'Maintenance Records'},
        {value: 'regDocs', label: 'Registration Docs'},
        {value: 'imageFiles', label: 'Asset Images'}
      ]
    },
    {
      label: 'Watercraft',
      value: 'watercraft',
      fileTypes: [
        {value: 'huPlDocs', label: 'Hurricane Plan Docs'},
        {value: 'capResumeDocs', label: 'Captain Resume Docs'},
        {value: 'mValueDocs', label: 'Market Value Docs'},
        {value: 'rValueDocs', label: 'Replacement Value Docs'},
        {value: 'imageFiles', label: 'Asset Images'}
      ]
    },
    {
      label: 'Aircraft',
      value: 'aircraft',
      fileTypes: [
        {value: 'marketValueDocs', label: 'Market Value Docs'},
        {value: 'rValueDocs', label: 'Replacement Value Docs'},
        {value: 'imageFiles', label: 'Asset Images'}
      ]
    },
    {
      label: 'Equine',
      value: 'equine',
      fileTypes: [
        {value: 'trainingDocs', label: 'Training Docs'},
        {value: 'imageFiles', label: 'Asset Images'}
      ]
    }
  ],
  policy: [
    {
      label: 'Real Estate',
      value: 'realEstate',
      fileTypes: [{value: 'policyDocs', label: 'Policy Documents'}]
    },
    {
      label: 'Collections',
      value: 'collection',
      fileTypes: [{value: 'policyDocs', label: 'Policy Documents'}]
    },
    {
      label: 'Automobiles',
      value: 'automobile',
      fileTypes: [
        {value: 'aidCard', label: 'Automobile ID card'},
        {value: 'crtIns', label: 'Certificate of Insurance'},
        {value: 'policyDocs', label: 'Policy Documents'}
      ]
    },
    {
      label: 'Watercraft',
      value: 'watercraft',
      fileTypes: [{value: 'policyDocs', label: 'Policy Documents'}]
    },
    {
      label: 'Aircraft',
      value: 'aircraft',
      fileTypes: [{value: 'policyDocs', label: 'Policy Documents'}]
    },
    {
      label: 'Equine',
      value: 'equine',
      fileTypes: [{value: 'policyDocs', label: 'Policy Documents'}]
    },
    {
      label: 'Umbrella',
      value: 'umbrella',
      fileTypes: [{value: 'policyDocs', label: 'Policy Documents'}]
    },
    {
      label: 'Misc',
      value: 'misc',
      fileTypes: [{value: 'policyDocs', label: 'Policy Documents'}]
    }
  ],
  entity: [
    {
      label: 'Boards',
      value: 'board',
      fileTypes: [
        {value: 'indemnityDocs', label: 'Indemnity Docs'},
        {value: 'doDocs', label: 'D&O Docs'}
      ]
    },
    {
      label: 'Entities',
      value: 'entity',
      fileTypes: [
        {value: 'opAgreement', label: 'Operating Agreements'},
        {value: 'einFiling', label: 'EIN Filing'},
        {value: 'empDocs', label: 'Employment Docs'}
      ]
    },
    {
      label: 'Trusts & Estates',
      value: 'trust',
      fileTypes: [{value: 'entityDocs', label: 'Entity Planning Docs'}]
    },
    {
      label: 'Clubs',
      value: 'club',
      fileTypes: [
        {value: 'byLaws', label: 'By Laws'},
        {value: 'misc', label: 'Miscellaneous'}
      ]
    }
  ],
  claim: CLAIM_TYPE.map((item) => ({...item, fileTypes: [{value: 'claimDocs', label: 'Claim Documents'}]})),
  government: [
    {
      label: 'License',
      value: 'license',
      fileTypes: [
        {value: 'driverLicenseDoc', label: 'Driver License'},
        {value: 'pilotLicenseDoc', label: 'Pilot License'},
        {value: 'captainLicenseDoc', label: 'Captain License'},
        {value: 'motorVehicleClaimsDoc', label: 'Motor Vehicle Claim'},
        {value: 'motorVehicleReportDoc', label: 'Motor Vehicle Report'}
      ]
    },
    {
      label: 'Passport',
      value: 'passport',
      fileTypes: [{value: 'passportDoc', label: 'Passport Doc'}]
    },
    {
      label: 'Family',
      value: 'family',
      fileTypes: [{value: 'familyDocuments', label: 'Family Docs'}]
    }
  ]
};

export const fileVaultLabelHelpers = {
  asset: (item) => item.nickName,
  policy: (item) => item.nickName || item.policyName,
  entity: (item) => item.nickName || item.name,
  claim: (item) => item.nickName || item.policyName || item.policyNumber,
  government: (item) => item.title || item.id
};
